import React from "react";
import BlogFormPage from "../components/blogs/BlogFormPage";

const BlogCreate = () => <BlogFormPage mode="create" />;

export default BlogCreate;
